import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

import { createScpDetailViewRouteMap } from './detailed-view'

export const createSharedCollectionPointsRouteMap = (prefix: string) => ({
  '/:id': (id: string) =>
    pathJoin(prefix)(id).chainMapAuto(createScpDetailViewRouteMap, {
      title: <T _str="Shared service" />,
      breadCrumbTitle: <T _str="Details" />,
    }),
  create: pathJoin(prefix)('create').chainWithTitle({
    title: <T _str="New service" />,
    breadCrumbTitle: <T _str="New" />,
  }),
  'edit/:id': (id: string) =>
    pathJoin(prefix)('edit')(id).chainWithTitle({
      title: <T _str="Edit" />,
      breadCrumbTitle: <T _str="Edit" />,
    }),
  roles: pathJoin(prefix)('roles').chainWithTitle({
    title: <T _str="Shared service roles" />,
    breadCrumbTitle: <T _str="Roles" />,
  }),
  // NEXUS-664: the compliance review queue (register-basis / municipality /
  // outside-radius), reachable from the SCP area.
  compliance: pathJoin(prefix)('compliance').chainWithTitle({
    title: <T _str="Compliance" />,
    breadCrumbTitle: <T _str="Compliance" />,
  }),
})
